export default __webpack_public_path__ + "static/media/Bulletin.b92c6775.svg";